module.exports = __webpack_public_path__ + "static/images/vip-start-btn.png?v=0dbafb3";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/images/vip-start-btn.png
// module id = XvhV
// module chunks = 1